import { useTelegramMiniApp } from '~/composables/use-telegram-mini-app'

declare global {
  interface Window {
    _telegramInitData: string
  }
}

export default defineNuxtPlugin(async () => {
  const { initDataStored, initMiniAppSafely } = useTelegramMiniApp()

  await initMiniAppSafely()
  window._telegramInitData = initDataStored.value
})
